module.exports = __webpack_public_path__ + "static/media/hero-main.83ab2914.jpg";